import { api } from "@app/api";
import { defaultEntity } from "@app/hal";
import { schema } from "@app/schema";
import type { DeploySetting, DeploySettingResponse } from "@app/types";

export const defaultSettingResponse = (
  s: Partial<DeploySettingResponse> = {},
): DeploySettingResponse => {
  const now = new Date().toISOString();
  return {
    id: 0,
    settings: {},
    sensitive_settings: {},
    created_at: now,
    updated_at: now,
    _type: "setting",
    ...s,
  };
};

const deserializeSetting = (payload: DeploySettingResponse): DeploySetting => ({
  id: `${payload.id}`,
  settings: payload.settings || {},
  sensitiveSettings: payload.sensitive_settings || {},
  createdAt: payload.created_at,
  updatedAt: payload.updated_at,
});

export const selectSettingById = schema.settings.selectById;

export const fetchSettingById = api.get<{
  id: string;
  withSensitiveExtras?: boolean;
}>("/settings/:id");

export const settingEntities = {
  setting: defaultEntity({
    id: "setting",
    save: schema.settings.add,
    deserialize: deserializeSetting,
  }),
};
